  <div class="container-fluid">
 	 <div class="row justify-content-around bg-white form-inline">
     	<span class="h3 d-none d-md-block ml-2 mt-4 mb-4">{{title}}</span>
     	<span class="h5 d-md-none d-xs-block mt-4 ml-2">{{title}}</span>
     	<button class="btn btn-outline-secondary mr-2" (click)="goBack()">Back</button>
     </div>
  </div>
  